import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeLADClaimPrintForm } from './normalize';

export const fetchLADClaimPrintForm = createProvider(api.fetchLADClaimPrintForm)
  .andThen((res) => normalizeLADClaimPrintForm(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
